<template>
  <v-app>
    <DisconnectDialog
      :enable="disconnectDialogValue"
      :message="disconnectDialogMessage"
    />
    <router-view></router-view>
  </v-app>
</template>

<script>
import Vue from 'vue'
import store from '@/store'
import { TABLE } from '@/constants/tableNames'
import { DisconnectDialog } from '@leapsight/portal'

export default Vue.extend({
  name: 'App',
  components: {
    DisconnectDialog
  },
  data: () => ({}),
  async mounted() {
    store.state.indexDB.version(1).stores({
      [TABLE.THINGS]:
        'id++,account_id,aliases_qty,config,created_timestamp,info,metadata,reported_state,things,type,personsId,checkedFrom',
      [TABLE.TAGS]: 'id++,label,color,personsId'
    })

    await store.state.indexDB.open()
  },
  computed: {
    disconnectDialogValue() {
      return this.$store.state.disconnectDialogValue
    },
    disconnectDialogMessage() {
      return this.$store.state.disconnectDialogMessage
    }
  }
})
</script>
<style scoped></style>
